import { getExamInfo, getSelectedExamInfo } from "modules/platform-components/utils/configuration";
import React from "react";
import Select from "react-select";
import { colourStyles } from "./create-exam/tablist";

const ExamForm = ({
  examid,
  register,
  errors,
  watch,
  onChangeBranch,
  branches,
  subjects,
  batches,
  onChangeBatch,
  setSubjectValue,
  branchValue,
  subjectValue,
  setFirstTimeApiCall
}) => {
    return (
        <>
        <div className="col-xs-12 col-sm-6 col-md-6 col-lg-6">
                  <div className="form-sub-div">
                    <label className="form-label">Exam Name *</label>
                    <div className="form-elements">
                      <input
                        class="form-details"
                        type="text"
                        placeholder="Exam Name"
                        name="examName"
                        disabled={examid}
                        defaultValue={
                          examid ? getSelectedExamInfo().examName : ""
                        }
                        ref={register({
                          required: true,
                          validate: (value) => {
                            if (!examid) {
                              return !getExamInfo()
                                ?.map((e) => e?.examName?.toUpperCase())
                                ?.includes(value.toUpperCase());
                            }
                            return true;
                          },
                        })}
                      />
                      <div class="error-msg">
                        {errors?.examName?.type === "required" &&
                          "Exam Name is Required"}
                        {errors?.examName?.type === "validate" &&
                          "Exam Name is Already Exists"}
                      </div>
                    </div>
                  </div>
                  {examid && (
                    <div className="form-sub-div">
                      <label className="form-label">Exam Id *</label>
                      <div className="form-elements">
                        <input
                          class="form-details"
                          type="text"
                          placeholder="Exam Id"
                          name="examId"
                          disabled
                          defaultValue={getSelectedExamInfo().examId}
                          ref={register({
                            required: true,
                          })}
                        />
                      </div>
                    </div>
                  )}

                  <div class="form-sub-div">
                    <label class="form-label">Mode *</label>
                    {!examid && (
                      <div class="form-elements">
                        <div class="form-radio-main-div">
                          <div class="form-radio-div">
                            <input
                              class="radio-btn-common"
                              name="creationType"
                              type="radio"
                              disabled={examid}
                              value="Automatic"
                              ref={register({ required: true })}
                            />
                            <span class="radio-btn-text">Automatic</span>
                          </div>
                          <div class="form-radio-div">
                            <input
                              class="radio-btn-common"
                              name="creationType"
                              type="radio"
                              disabled={examid}
                              value="Manual"
                              ref={register({ required: true })}
                            />
                            <span class="radio-btn-text">Manual</span>
                          </div>
                        </div>
                        <div class="error-msg">
                          {" "}
                          {errors?.creationType && "Mode is Required"}
                        </div>
                      </div>
                    )}
                    {examid && (
                      <div className="form-elements">
                        <input
                          class="form-details"
                          type="text"
                          placeholder="Mode"
                          name="creationType"
                          disabled
                          defaultValue={getSelectedExamInfo().examCreationType}
                          ref={register({
                            required: true,
                          })}
                        />
                      </div>
                    )}
                  </div>
                  <div class="form-sub-div">
                    <label class="form-label">Exam Complexity</label>
                    <div class="form-elements">
                      <select
                        class="form-details"
                        name="complexity"
                        disabled={examid}
                        defaultValue={
                          examid ? getSelectedExamInfo().examType : ""
                        }
                        ref={register({ required: true })}
                      >
                        <option value="Easy">Easy</option>
                        <option value="Medium">Medium</option>
                        <option value="High">High</option>
                      </select>
                    </div>
                  </div>
                  <div class="form-sub-div">
                    <label class="form-label">Exam Type *</label>
                    <div class="form-elements">
                      <div class="form-radio-main-div">
                        <div class="form-radio-div">
                          <select
                            class="form-details-align-horizontal"
                            name="examAvailableType"
                            disabled={examid}
                            defaultValue={
                              examid
                                ? getSelectedExamInfo().examAvailableType
                                : ""
                            }
                            ref={register({ required: true })}
                          >
                            <option value="Free">Free</option>
                            <option value="Price">Price</option>
                          </select>
                          {watch("examAvailableType") === "Price" && (
                            <div class="form-radio-div">
                              <span class="radio-btn-text">INR</span>
                              <input
                                class="form-details-align-horizontal"
                                type="number"
                                name="examCost"
                                disabled={examid}
                                defaultValue={
                                  examid ? getSelectedExamInfo().examCost : ""
                                }
                                ref={register({
                                  required: true,
                                  validate: (value) => value > 0,
                                })}
                              />
                            </div>
                          )}
                        </div>
                      </div>
                      <div class="error-msg">
                        {" "}
                        {errors?.examCost &&
                          "Exam Cost is required and should be greater than zero"}
                      </div>
                    </div>
                  </div>
                </div>

                <div class="col-xs-12 col-sm-6 col-md-6 col-lg-6">
                  {
                    <div class="form-sub-div">
                      <label class="form-label">Branch *</label>
                      <div class="form-elements">
                        <select
                          class="form-details"
                          name="branchId"
                          disabled={examid}
                          value={watch("branchId") ?? branchValue }
                          ref={register({
                            validate: (value) => value !== "",
                          })}
                          onChange={(e) => {
                            onChangeBranch(e.target.value)
                            setFirstTimeApiCall(true)
                          }}
                        >
                          <option disabled value="">
                            Please Select Branch
                          </option>
                          {branches.map((ele) => (
                            <option key={ele?.branchId} value={ele?.branchId}>
                              {ele?.branchName}
                            </option>
                          ))}
                        </select>
                        <div class="error-msg">
                          {" "}
                          {(errors?.branchId?.type === "validate" ||
                            (watch("creationType")?.toUpperCase() ===
                              "MANUAL" &&
                              watch("branchId") === "")) &&
                            "Branch Name is Required"}{" "}
                        </div>
                      </div>
                    </div>
                  }
                  <div class="form-sub-div">
                    <label class="form-label">Batch *</label>
                    <div class="form-elements">
                      {batches && batches.length > 0 && (
                        <select
                          class="form-details"
                          name="batchId"
                          disabled={examid}
                          defaultValue={
                            examid ? getSelectedExamInfo().batchId : ""
                          }
                          value={watch("batchId")}
                          ref={register({
                            validate: (value) => value !== "",
                          })}
                          onChange={(e) => {
                            onChangeBatch(e.target.value)
                            setFirstTimeApiCall(true)
                          }}
                        >
                          <option disabled value="">
                            Please Select Batch
                          </option>
                          {batches.map((ele) => (
                            <option key={ele?.batchId} value={ele?.batchId}>
                              {ele?.batch}
                            </option>
                          ))}
                        </select>
                      )}
                      <div class="error-msg">
                        {" "}
                        {(errors?.batchId?.type === "validate" ||
                          (watch("creationType")?.toUpperCase() === "MANUAL" &&
                            watch("batchId") === "")) &&
                          "Batch Name is Required"}{" "}
                      </div>
                    </div>
                  </div>
                  <div class="form-sub-div">
                    <label class="form-label">Exam Category</label>
                    <div class="form-elements">
                      <select
                        class="form-details"
                        name="examCategory"
                        disabled={examid}
                        defaultValue={
                          examid ? getSelectedExamInfo().examCategory : ""
                        }
                        ref={register({ required: true })}
                        onChange={(e) => {
                          setSubjectValue([]);
                          setFirstTimeApiCall(true)
                        }}
                      >
                        <option value="SUBJECT WISE TEST">
                          Subject Wise Test
                        </option>
                        <option value="GRAND TEST">Grand Test</option>
                      </select>
                    </div>
                  </div>

                  {true && (
                    <div class="form-sub-div">
                      <label class="form-label">Subject *</label>
                      <div class="form-elements" style={{ fontSize: "15px" }}>
                        <Select
                          class="form-details"
                          placeholder="select the subject"
                          name="subjectCode"
                          isDisabled={examid}
                          value={subjectValue}
                          options={(watch("examCategory") !==
                          "SUBJECT WISE TEST"
                            ? [
                                { subject: "Select All", subjectId: "all" },
                                ...subjects,
                              ]
                            : subjects
                          ).map((el) => {
                            return {
                              value: el.subjectId,
                              label: el.subject,
                            };
                          })}
                          components={{
                            IndicatorSeparator: () => null,
                          }}
                          styles={colourStyles}
                          isMulti={
                            watch("examCategory") !== "SUBJECT WISE TEST"
                          }
                          onChange={(e) => {
                            if (watch("examCategory") !== "SUBJECT WISE TEST") {
                              if (e.find((option) => option.value === "all")) {
                                const mappedSubject = subjects.map((el) => {
                                  return {
                                    value: el.subjectId,
                                    label: el.subject,
                                  };
                                });
                                setSubjectValue(mappedSubject);
                              } else {
                                setSubjectValue(e);
                              }
                            } else {
                              setSubjectValue([e]);
                            }
                          setFirstTimeApiCall(true)
                          }}
                        />
                      </div>
                    </div>
                  )}
                </div>
        </>)
        }

export default ExamForm